<template>
  <div class="home " v-loading="loading" element-loading-text="加载中请稍后。。。">
    <div class="contentWidth">

      <div class="flexBetween home-top-login">
        <Search @updateValue="updateValue" @updateCityCode="updateCityCode" :isPosition="true" ></Search>
        <div class="login-more flexBetween itemsCenter" v-if="!isLogin">
            <div class="flex itemsCenter" >
              <img src="../../assets/images/newicon/loginout.png"/>
              <router-link class="login-label" to="/login">登陆</router-link>
            </div>
            <div @click="gotoMoreJob">查看更多职位</div>
        </div>
        <div v-else class="login-more-position">
            
            <div @click="gotoMoreJob">查看更多职位</div>
        </div>
      </div>
    <!-- 搜索条件 -->
      <SearchData @updateFormData="updateFormData" ></SearchData>
      <div class="main-box">
        <div class="flex ">
          <p class="main-box-recommend flex">
          
           <span class="recommend-default" 
           @click="getRecommedCompany('')" :class="conditions.positionKind===''?'active':''">默认推荐</span>
           
           <span v-if="shlefInfo" class="flex recommend-hope">
              
              <span class="recommend-hope-title" v-if="hopeJobs && hopeJobs.length>0">根据求职期望推荐:</span>
              <span class="recommend-hope-title" v-else @click="gotoResume">添加求职期望，更精准为您匹配</span>
              <span v-for="item in hopeJobs" 
                 :key="item.id"
                 @click="getRecommedCompany(item.desirePositionType)" 
                  class="recommend-hope-item" 
                  :class="item.desirePositionType===conditions.positionKind?'active':''">{{item.desirePositionTypeName}}</span>
           </span>
         
            <span v-else @click="goLogin" class="recommend-hope-title">根据求职期望推荐</span>
          </p>
         

        </div>
        <div class="flexColumn">
          <div class="flex main-box-items flexWarp">
            <item v-for="item in companys" :key="item.id" :datas="item"></item>
          </div>
          <pagination
              :total="pagination.totalRow"
              v-model="conditions.pageIndex"
              v-if="pagination.totalRow>0 && !loading"
              @change="pageChange">
          </pagination>
          <prompt v-if="companys.length < 1 && !loading"></prompt>
        </div>
      </div>
  </div>
  <GetCityByIp></GetCityByIp>
  </div>
</template>

<script>
import defaultAvatar from "../../assets/images/default-avatar.png";
import { mapActions, mapState,mapGetters } from "vuex";
import Search from '../../components/search.vue';
import SearchData from '../job/components/searchData.vue';
import Item from './components/item.vue'
import GetCityByIp from '../../components/getCurrentCity.vue'


export default {
  components: {
    Search,SearchData,Item,GetCityByIp
  },
  name: "home",
  data() {
    return {
      recommend:'',
      conditions: {
        cityCode:'',//城市code
        industryType:"", //行业类型 
        financingType: "", //融资情况
        companyType:"", //企业性质
        scaleType:'',//公司规模
        positionKind:'', //职位类型-->用户的期望值
        pageIndex: 1, //当前页码
        pageSize: 8,
      },
      loading: false,
      showLogin:false,

    };
  },
  computed: {
    ...mapState({
      companys: state => state.company.companyList, //公司列表
      pagination: state => state.company.pagination,
      hopeJobs:state => state.company.hopeJobs,
      shlefInfo: state => state.user.info, //个人信息
      cityCodes:state => state.jobs.cityCodeText,
    }),
    ...mapGetters([
       "qualificationsType",//学历要求
       "industryType",//行业类型
       "positionType",//职位类型
       "scale",       //公司规模
       "financingType",//融资情况
       "companyType", //公司类型
       "isLogin"
    ]),
    defaultAvatar() {
      return defaultAvatar;
    }
  },
  async created() {
    await this.getCompanyList();  //公司列表
    await this.getPositionArea();
    await this.getHopeJob();
  },
  methods: {
    ...mapActions([
      "getCompany",  //公司列表
      "getPositionArea",
      "getJobs",
      "login",
      "getHopeJob"
      
    ]),
    goLogin(){
      this.$router.push({
          path:`/login`
      })
    },
    gotoResume(){
      this.$router.push("/myresume");
    },
    //根据推荐获取公司列表数据
    getRecommedCompany(id){
       this.conditions.positionKind = id;
       this.search();
      
    },

    //查看更多职位
    gotoMoreJob(){
      this.$router.push({
          path:`/job`
      })
    },

    //页码改变请求数据
    pageChange(e){
      this.conditions.pageIndex = e;
      this.getCompanyList();
    },
    //根据条件查询职位列表
    updateFormData(formData){
      console.log(formData,'公司查询数据')
      // let keys=["companyType","industryType",'scaleType',"financingType",'cityCode',]
      for(let key in formData){
        this.conditions[key] = formData[key]
      }
      this.search();
    },

    updateCityCode(){
        this.conditions.cityCode = this.cityCodes;
        this.search();
      },

    //根据关键字或热门职位查询
    updateValue(value){
      let name = value;
      this.$router.push({
          path: "/job",
          query: {...name}
        });
    },

    // 获得公司列表
    async getCompanyList() {
      this.loading = true;
      await this.getCompany({
        ...this.conditions
      })
      this.loading = false;
    },

    async search() {
      this.conditions.pageIndex = 1;
      this.getCompanyList();
    },
   
   
   

   
  },
  // watch: {
  //   conditions: {
  //     async handler() {
  //       await this.getCompanyList();
  //     },
  //     deep: true
  //   },
  //   pageIndex() {
  //     this.getCompanyList();
  //   }
  // }
};
</script>
<style lang="less" scoped>
@mianColor:#287CF3;
@whiteColor:#fff;
@mainFontCol:rgba(0,0,0,0.85);
@secondfontCol:rgba(0,0,0,0.5);
@yellowColor:#FF8A16;
.home {
  padding-top: 30px;
  background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
  padding-bottom: 30px;
  .main-box{
    &-recommend{
      height: 36px;
      line-height: 36px;
      // width: 270px;
      background: rgba(40,124,243,0.2);
      border-radius: 6px;
      padding:2px 4px;
      text-align: center;
      span{
        cursor: pointer;
      }
      .recommend-default{
        width: 100px;
        line-height: 32px;
      }
      .recommend-hope-title{
        padding: 0 4px;
        line-height: 32px;
        margin-left: 14px;
      }
      .recommend-hope-item{
        padding: 0 10px;
        line-height: 32px;
        margin-right: 6px;
      }
      div{
        width: 50%;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        text-align: center;
        cursor: pointer;
      }      
      .active{
        background: @whiteColor;
        border-radius: 6px;
        color: @mianColor;
      }
    }
    &-items{
      margin-top: 24px;
      align-items: flex-start;
      width: 100%;
    }

    /deep/.el-pager{
      li{
        background: none;
        .active{
          background-color: none;

        }
      }
    } 
  }
  .home-top-login{
      align-items: flex-start;
      .mian-contents{
        width: 939px;
      }
      .login-more{
          box-sizing: border-box;
          width: 310px;
          height: 44px;
          line-height: 44px;
          box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
          border-radius: 6px;
          border: 1px solid @mianColor;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @mianColor;
          letter-spacing: 2px;
          padding: 0 32px;
          cursor: pointer;
          .login-label{
              color: @mianColor;
          }
          div{
              position: relative;
              &:first-child{
                  &::after{
                      content: '';
                      position: absolute;
                      width: 1px;
                      height: 24px;
                      right: -24px;
                      background: @mianColor;
                  }
              }
          }
          img{
              width: 24px;
              height: 24px;
              margin-right: 6px;
          }
      }
      .login-more-position{
          width: 190px;
          text-align: center;
          height: 44px;
          line-height: 44px;
          box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
          border-radius: 6px;
          border: 1px solid @mianColor;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @mianColor;
          letter-spacing: 2px;
          cursor: pointer;
      }
  }
}
</style>
